module.exports = __webpack_public_path__ + "static/media/instagram.9cba4898.svg";